@if (resource) {
  <span [textContent]="label"></span>
  <attribute-help-text [attribute]="attribute"
    [attributeScope]="attributeScope" />
}

@if (error) {
  <span>
    <i class="icon icon-error"></i>
    <em [textContent]="error"></em>
  </span>
}
